import { Injectable } from '@angular/core';
import { BaseDbService, UserService } from './user.service';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from 'angularfire2/database';
import { UserGroupService } from './user-group.service';
import { Group } from '../models/group';

@Injectable({
  providedIn: 'root'
})
export class GroupService extends BaseDbService {
  groupsRef: AngularFireList<any>;
  constructor(
    protected db: AngularFireDatabase,
    private userGroupService: UserGroupService) {
    super(db, "groups");
    this.groupsRef = this.getListRef();
  }

  add(group: any): Promise<any> {
    return new Promise(resolve => {
      this.groupsRef.push(group).then(res => {
        this.userGroupService.add(this.CurrentUser.uid, res.key);
        resolve(res);
      });
    })
  }

  get(id: string) : AngularFireObject<Group> {
    return this.db.object<Group>(`${this.dbPath}/${id}`);

    // return this.getById(id);
  }

  updateSettings(group: Group): Promise<void> {
    return this.get(group.id).update({
      name: group.name,
      rules: group.rules,
      share: group.share,
      startDate: group.startDate,
      meetups: group.meetups
    });
  }

}


